/* global saveAs:true */
(function() {
    'use strict';

    angular.module('eDocumentsApp').factory('DocumentationUtils', DocumentationUtils);

    DocumentationUtils.$inject = ['$http', '$sce', '$translate', '$window', 'Notification'];

    function DocumentationUtils($http, $sce, $translate, $window, Notification) {
        var MANUAL_BASE = '/content/documentation/manual';

        return {
            userManualUrl: userManualUrl,
            openUserManual: openUserManual,
            downloadAMASAFEUserManual: downloadAMASAFEUserManual
        };

        /**
         * The user manual is a static page under /content/, which SecurityConfiguration puts in
         * web.ignoring(). That matters: this link is offered on the sign-in screen, so it has to
         * work for someone who is not authenticated.
         *
         * It previously called /api/documentation/userManual/downloadPdf, which falls under
         * /api/** -> authenticated(), so anonymous visitors got a 401. See docs/manual/ADR-001.
         */
        function userManualUrl(languageKey) {
            var language = languageKey || $translate.use() || 'pt-pt';
            return MANUAL_BASE + '/' + language + '.html';
        }

        function openUserManual(languageKey) {
            $window.open(userManualUrl(languageKey), '_blank', 'noopener');
        }

        function downloadAMASAFEUserManual() {
            $http.get('/api/documentation/amaSafeUserManual/downloadPdf', { responseType: 'arraybuffer' }).then(
                function successCallback(response) {
                    var blob = new Blob([response.data], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(blob);
                    $window.open($sce.trustAsResourceUrl(fileURL), '_blank');
                    saveAs(blob, 'amaSafeCredential_userManual.pdf', true);
                },
                function errorCallback() {
                    // Notification was previously used here without being injected, so this
                    // handler threw a ReferenceError and the user saw nothing at all.
                    Notification.error({ message: $translate.instant('error.errorGeneratingFile'), delay: '' });
                }
            );
        }
    }
})();
